import type { CategoriaConfig } from './configuracoesCampanhas';

/**
 * Configuração por Participante por Campanha
 * Um participante pode estar em N campanhas, cada uma com parâmetros diferentes.
 * Aqui guardamos as configurações personalizadas do participante DENTRO de cada campanha.
 */
export interface ParticipanteCampanhaConfig {
  participanteId: string;
  campanhaId: string;
  empresaId: string;
  // Campos personalizáveis por campanha por participante
  limiteResgateDiarioPersonalizado?: number;
  limiteResgateMensalPersonalizado?: number;
  taxaProcessamentoPixPersonalizada?: number;
  prazoAprovacaoSaquePersonalizado?: number;
  ativo?: boolean; // se a config individual está ativa para esta campanha
  ultimaAlteracao: string;
  alteradoPor: string;
}

export const participanteCampanhaConfigs: ParticipanteCampanhaConfig[] = [
  // João Pedro Silva (PART-C1-001) — em CAMP-001 e CAMP-002
  {
    participanteId: 'PART-C1-001',
    campanhaId: 'CAMP-001',
    empresaId: 'EMP-001',
    limiteResgateDiarioPersonalizado: 5000,
    limiteResgateMensalPersonalizado: 20000,
    ativo: true,
    ultimaAlteracao: '2026-05-01T10:00:00Z',
    alteradoPor: 'André Costa',
  },
  {
    participanteId: 'PART-C1-001',
    campanhaId: 'CAMP-002',
    empresaId: 'EMP-001',
    ativo: false,
    ultimaAlteracao: '2026-04-20T14:30:00Z',
    alteradoPor: 'André Costa',
  },
  // Maria Fernanda Costa (PART-C1-002) — em CAMP-001 e CAMP-002
  {
    participanteId: 'PART-C1-002',
    campanhaId: 'CAMP-001',
    empresaId: 'EMP-001',
    limiteResgateDiarioPersonalizado: 8000,
    taxaProcessamentoPixPersonalizada: 1.0,
    prazoAprovacaoSaquePersonalizado: 12,
    ativo: true,
    ultimaAlteracao: '2026-05-03T09:15:00Z',
    alteradoPor: 'André Costa',
  },
  {
    participanteId: 'PART-C1-002',
    campanhaId: 'CAMP-002',
    empresaId: 'EMP-001',
    limiteResgateDiarioPersonalizado: 6000,
    ativo: true,
    ultimaAlteracao: '2026-05-05T11:00:00Z',
    alteradoPor: 'André Costa',
  },
  // Carlos Eduardo Mendes (PART-C1-003) — em CAMP-001 e CAMP-002
  {
    participanteId: 'PART-C1-003',
    campanhaId: 'CAMP-001',
    empresaId: 'EMP-001',
    ativo: false,
    ultimaAlteracao: '2026-04-10T10:00:00Z',
    alteradoPor: 'André Costa',
  },
  {
    participanteId: 'PART-C1-003',
    campanhaId: 'CAMP-002',
    empresaId: 'EMP-001',
    limiteResgateMensalPersonalizado: 15000,
    taxaProcessamentoPixPersonalizada: 0.8,
    ativo: true,
    ultimaAlteracao: '2026-04-25T16:00:00Z',
    alteradoPor: 'André Costa',
  },
  // Ana Paula Ribeiro (PART-C1-004) — em CAMP-001
  {
    participanteId: 'PART-C1-004',
    campanhaId: 'CAMP-001',
    empresaId: 'EMP-001',
    limiteResgateDiarioPersonalizado: 3000,
    prazoAprovacaoSaquePersonalizado: 6,
    ativo: true,
    ultimaAlteracao: '2026-04-15T08:30:00Z',
    alteradoPor: 'André Costa',
  },
  // Roberto Dias (PART-C1-005) — em CAMP-002
  {
    participanteId: 'PART-C1-005',
    campanhaId: 'CAMP-002',
    empresaId: 'EMP-001',
    limiteResgateDiarioPersonalizado: 2000,
    ativo: true,
    ultimaAlteracao: '2026-04-18T13:45:00Z',
    alteradoPor: 'André Costa',
  },
  // Luciana Torres (PART-C3-001) — em CAMP-003 e CAMP-005
  {
    participanteId: 'PART-C3-001',
    campanhaId: 'CAMP-003',
    empresaId: 'EMP-002',
    ativo: false,
    ultimaAlteracao: '2026-04-01T10:00:00Z',
    alteradoPor: 'Ricardo Ferreira',
  },
  {
    participanteId: 'PART-C3-001',
    campanhaId: 'CAMP-005',
    empresaId: 'EMP-002',
    limiteResgateDiarioPersonalizado: 3500,
    limiteResgateMensalPersonalizado: 12000,
    ativo: true,
    ultimaAlteracao: '2026-04-10T09:00:00Z',
    alteradoPor: 'Ricardo Ferreira',
  },
  // Bruno Oliveira (PART-C3-002) — em CAMP-003
  {
    participanteId: 'PART-C3-002',
    campanhaId: 'CAMP-003',
    empresaId: 'EMP-002',
    limiteResgateDiarioPersonalizado: 2500,
    limiteResgateMensalPersonalizado: 10000,
    taxaProcessamentoPixPersonalizada: 1.5,
    ativo: true,
    ultimaAlteracao: '2026-05-02T14:00:00Z',
    alteradoPor: 'Ricardo Ferreira',
  },
  // Daniel Souza (PART-C4-001) — em CAMP-004
  {
    participanteId: 'PART-C4-001',
    campanhaId: 'CAMP-004',
    empresaId: 'EMP-003',
    ativo: false,
    ultimaAlteracao: '2026-04-05T11:20:00Z',
    alteradoPor: 'Fernanda Costa',
  },
  // Juliana Martins (PART-C4-002) — em CAMP-004
  {
    participanteId: 'PART-C4-002',
    campanhaId: 'CAMP-004',
    empresaId: 'EMP-003',
    limiteResgateDiarioPersonalizado: 1000,
    prazoAprovacaoSaquePersonalizado: 6,
    ativo: true,
    ultimaAlteracao: '2026-04-08T10:00:00Z',
    alteradoPor: 'Fernanda Costa',
  },
];

/** Busca configuração personalizada de um participante em uma campanha */
export function getConfigParticipanteCampanha(
  participanteId: string,
  campanhaId: string
): ParticipanteCampanhaConfig | undefined {
  return participanteCampanhaConfigs.find(
    (c) => c.participanteId === participanteId && c.campanhaId === campanhaId
  );
}

/** Busca TODAS as configurações de um participante (em todas as campanhas) */
export function getConfigsPorParticipante(
  participanteId: string
): ParticipanteCampanhaConfig[] {
  return participanteCampanhaConfigs.filter((c) => c.participanteId === participanteId);
}

/** Verifica se o participante tem configuração personalizada em uma campanha */
export function temConfigPersonalizada(
  participanteId: string,
  campanhaId: string
): boolean {
  const cfg = getConfigParticipanteCampanha(participanteId, campanhaId);
  if (!cfg || !cfg.ativo) return false;
  return (
    cfg.limiteResgateDiarioPersonalizado !== undefined ||
    cfg.limiteResgateMensalPersonalizado !== undefined ||
    cfg.taxaProcessamentoPixPersonalizada !== undefined ||
    cfg.prazoAprovacaoSaquePersonalizado !== undefined
  );
}

/** Salva (upsert) configuração de participante-campanha */
export function salvarConfigParticipanteCampanha(
  config: Partial<ParticipanteCampanhaConfig> & { participanteId: string; campanhaId: string; empresaId: string }
): void {
  const idx = participanteCampanhaConfigs.findIndex(
    (c) => c.participanteId === config.participanteId && c.campanhaId === config.campanhaId
  );
  if (idx >= 0) {
    participanteCampanhaConfigs[idx] = {
      ...participanteCampanhaConfigs[idx],
      ...config,
      ultimaAlteracao: new Date().toISOString(),
      alteradoPor: config.alteradoPor || 'Sistema',
    } as ParticipanteCampanhaConfig;
  } else {
    participanteCampanhaConfigs.push({
      participanteId: config.participanteId,
      campanhaId: config.campanhaId,
      empresaId: config.empresaId,
      limiteResgateDiarioPersonalizado: config.limiteResgateDiarioPersonalizado,
      limiteResgateMensalPersonalizado: config.limiteResgateMensalPersonalizado,
      taxaProcessamentoPixPersonalizada: config.taxaProcessamentoPixPersonalizada,
      prazoAprovacaoSaquePersonalizado: config.prazoAprovacaoSaquePersonalizado,
      ativo: config.ativo ?? true,
      ultimaAlteracao: new Date().toISOString(),
      alteradoPor: config.alteradoPor || 'Sistema',
    });
  }
}

/** Remove configuração de participante-campanha (reseta para padrão) */
export function removerConfigParticipanteCampanha(
  participanteId: string,
  campanhaId: string
): void {
  const idx = participanteCampanhaConfigs.findIndex(
    (c) => c.participanteId === participanteId && c.campanhaId === campanhaId
  );
  if (idx >= 0) {
    participanteCampanhaConfigs.splice(idx, 1);
  }
}

/** Retorna quais campanhas um participante está inscrito */
export function getCampanhasDoParticipante(
  participanteId: string,
  empresaId?: string
): { campanhaId: string; empresaId: string }[] {
  const configs = getConfigsPorParticipante(participanteId);
  if (empresaId) {
    return configs.filter((c) => c.empresaId === empresaId).map((c) => ({ campanhaId: c.campanhaId, empresaId: c.empresaId }));
  }
  return configs.map((c) => ({ campanhaId: c.campanhaId, empresaId: c.empresaId }));
}